module.exports = __webpack_public_path__ + "img/img-crm-coin.1af846e5.png";